module.exports = __webpack_public_path__ + "static/media/gym-2.5cd3fcfe.jpg";